import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AppFacade } from '../../facades/app.facade';
import { HandleTokenService } from '../services/handle-token.service';

import { APP_CONSTANTS as CONST } from '@app/app.constants';
import { URLS } from '@app/data/mo-api/url.constants';
import { environment } from '@environment';
import { ErrorService } from '../../domain/services/error.service';
import { APP_ROUTES as ROUTES } from '@app/app.routes';
import { UtilService } from '@app/services/util.service';

const API_URL = environment.api_url;

@Injectable()
export class AppInterceptorService implements HttpInterceptor {
  constructor(
    private _handleTokenService: HandleTokenService,
    private _appFacade: AppFacade,
    private _utilService: UtilService,
    private _errorService: ErrorService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this._sendRequest(req, next);
  }

  private _sendRequest(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const { url } = req;
    const isRequestAmazon = url.indexOf('s3.amazon') > -1;
    const isRequestOpenPay = req.url.indexOf(environment.openpay_url) > -1;
    const isOffersRequest = url.indexOf(URLS.OFFERS_BY_MERCHANT) > -1;
    const accessToken = this._handleTokenService.getAccessToken() ?? '';
    const transactionToken = this._handleTokenService.getTransactionToken() ?? '';
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
    };

    headers.Authorization = isOffersRequest
      ? `Bearer ${transactionToken}`
      : `Token: ${accessToken}`;

    const reqUpdated = req.clone({
      url: API_URL + url,
      setHeaders: headers,
    });

    return isRequestAmazon || isRequestOpenPay
      ? this._continueRequest(req, next)
      : this._continueRequest(reqUpdated, next);
  }

  private _continueRequest(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: any) => this._catchError(req, err)),
      map((response: any) => {
        this._checkTokenResponse(response);
        return response;
      })
    );
  }

  private _checkTokenResponse(response: any) {
    if (response.token) {
      this._handleTokenService.setAccessToken(response.token);
    }
    if (response.body && response.body.token) {
      this._handleTokenService.setAccessToken(response.body.token);
    }
    if (response.headers && response.headers.get('token')) {
      this._handleTokenService.setAccessToken(response.headers.get('token'));
    }
  }

  private _catchError(req: HttpRequest<any>, err: HttpErrorResponse) {
    const { status } = err;
    const route: string = ROUTES.ERROR;

    if (status > CONST.HTTP_CODES.BAD_REQUEST) {
      this._appFacade.closeSession();
      this._utilService.navigateTo(route);
    }

    return throwError(err);
  }
}
